import { useLocation, useNavigation } from 'react-router';

/**
 * Whether this tab's results are being replaced by a navigation in flight —
 * a filter apply, a sort change, or a brand toggle.
 *
 * The tab's controls all navigate, so between the click and the loader landing
 * the page shows a stale grid with nothing to say a click registered. Callers
 * dim the grid on this, matching the browse pages (`DirectoryUniformGrid`).
 *
 * Same-pathname only: moving to another tab or profile replaces the whole
 * section anyway, and dimming on the way out just makes the exit look broken.
 */
export const useTabResultsPending = (): boolean => {
    const location = useLocation();
    const navigation = useNavigation();
    return (
        navigation.state === 'loading' &&
        navigation.location?.pathname === location.pathname
    );
};

/** Grid classes for the pending state — kept in step with the browse grids. */
export const TAB_RESULTS_PENDING_CLASS =
    'pointer-events-none animate-pulse opacity-40';
